import api from "./api"
import app from "./app"
import integrations from "./integrations"

export default { api, app, integrations }
